<template>
	<div class='comment-container'>
		<div class='comment'>
			<a class='author-photo' v-if='value.created_by.photo_small' :href='`/profile/${value.created_by.id}/`'>
				<img :src='value.created_by.photo_small' >
			</a>
			<div class='author-comment'>
				<div class='author-comment-data-wrapper'>
					<a class='name' :href='`/profile/${value.created_by.id}/`'>
						{{value.created_by.name}}
					</a>
					<div class='comment-text'>
						{{value.text}}
					</div>
					<a class='comment-text' :href='`/profile/${profile.id}/`'>
						<img class='img-wrapper'
							:src='photo.image'
							v-for='(photo, p) in value.attachments'
							:key='`p-${p}`'
						>
					</a>
				</div>
				<div class='actions'>
					<div v-if="showDeleteBtn" class='reply comment__delete-btn' @click="deleteComment()">Delete</div>
					<div class='reply' @click='showReply=true'>
						• Reply
					</div>
					<div class='time'>
						• {{value.created_at|formatDate}}
					</div>
				</div>
			</div>
		</div>
		<MediaContainer v-model='media' hideButtonAdd />
		<div class='reply-action' v-show='showReply'>
			<a class='image-wrapper' v-if='profile.photo_small' :href='`/profile/${profile.id}/`'>
				<img :src='profile.photo_small' >
			</a>
			<div class='reply-field'>
				<input type='text'
					v-model='text'
					class='inp'
					placeholder='Write a comment...'
					v-on:keyup.enter='createComment'
					ref='input'
				>
				<MediaSlot :ratio='[178, 108]'
					@crop='cropHandle'
					v-model='mediaElem'
					v-if='media.length < 4'
				>
					<div class='upload-img-icon-wrap' >
						<svg xmlns='http://www.w3.org/2000/svg'
							width='19'
							height='16'
							viewBox='0 0 19 16'
							fill='none'>
							<path d='M17.5455 13.4444C17.5455 13.857 17.387 14.2527 17.1049 14.5444C16.8228 14.8361 16.4402 15 16.0413 15H2.50413C2.10521 15 1.72263 14.8361 1.44055 14.5444C1.15847 14.2527 1 13.857 1 13.4444V4.88889C1 4.47633 1.15847 4.08067 1.44055 3.78894C1.72263 3.49722 2.10521 3.33333 2.50413 3.33333H5.5124L7.01653 1H11.5289L13.0331 3.33333H16.0413C16.4402 3.33333 16.8228 3.49722 17.1049 3.78894C17.387 4.08067 17.5455 4.47633 17.5455 4.88889V13.4444Z'
								stroke='#5F5F5F'
								stroke-linecap='round'
								stroke-linejoin='round'/>
							<path d='M9.27362 12.4551C11.0309 12.4551 12.4554 11.0305 12.4554 9.27325C12.4554 7.51598 11.0309 6.09143 9.27362 6.09143C7.51635 6.09143 6.0918 7.51598 6.0918 9.27325C6.0918 11.0305 7.51635 12.4551 9.27362 12.4551Z'
								stroke='#5F5F5F'
								stroke-linecap='round'
								stroke-linejoin='round'/>
						</svg>
					</div>
				</MediaSlot >
				<div class='send-img-icon-wrap' @click='createComment()' v-if='showSendBtn'>
					<svg width='22'
						height='21'
						viewBox='0 0 22 21'
						fill='none'
						xmlns='http://www.w3.org/2000/svg'>
						<path d='M21.2311 1L14.0695 20L9.97722 11.45L0.769531 7.65L21.2311 1Z'
							stroke='#5F5F5F'
							stroke-linecap='round'
							stroke-linejoin='round'/>
					</svg>
				</div>
			</div>
		</div>
		<div v-if='replies.top.length && !showTop' @click='showTop=true' class='showMoreReplies'>Show more...</div>
		<div class='reply-container' v-if='replies.top.length && showTop'>
			<Reply v-for='(reply, r) in replies.top'
				:key='`top${r}`'
				:reply='reply'
				:post-id="postId" />
		</div>
		<div class='reply-container' v-if='replies.bottom.length'>
			<Reply v-for='(reply, r) in replies.bottom'
				:key='`borrom${r}`'
				:reply='reply'
				:post-id="postId" />
		</div>
	</div>
</template>

<script>
import global from '__jsVueMixin/global';
import Reply from './components/Reply/Reply.vue';
import api from '__jsVueApi';
import MediaContainer from '__jsVueSections/MediaContainer/MediaContainer.vue';
import MediaSlot from '__jsVueSections/MediaSlot/MediaSlot.vue';
import splitArray from '__jsVueMixin/splitArray';
import EventBus from '__jsEbentBus';

export default {
	name:       'Comment',
	mixins:     [global, splitArray],
	components: {
		Reply,
		MediaContainer,
		MediaSlot,
	},
	props:  {
		value: {
			type: Object
		},
		postId: Number
	},
	data() {
		return {
			text:      '',
			showReply:  false,
			showTop:   false,
			media:     [],
			mediaElem: {
				id:    false,
				image: {
					src:  false,
					blob: false
				}
			},
		};
	},
	async mounted() {
		// await this.getComment();
	},
	computed: {
		showSendBtn() {
			if (this.text) {
				return true;
			}
			if (this.media.length) {
				for (let i = 0; i < this.media.length; i++) {
					const el = this.media[i];
					if (el.image.src) {
						return true;
					}
				}
			}
			return false;
		},
		showDeleteBtn() {
			return this.value.is_owner || this.profile.is_admin;
		},
		profile() {
			return this.$store.state.profile.profile;
		},
		replies() {
			return this.splitArrayLast(this.value.replies, 2);
		},
	},
	methods: {
		cropHandle(photo) {
			this.media = [
				...this.media, {
					id:    photo.id,
					image: {
						src:  photo.image.src,
						blob: photo.image.blob,
					}
				}
			];
		},
		async getComment() {
			await axios.get(api.posts.comments.get(this.value.id)).then((response) => {
				this.$emit('input', response.data);
			});
		},
		async createComment() {
			if (this.showSendBtn) {
				let attachments = [];
				this.media.map((el) => {
					if (el.image.src) {
						attachments.push({
							image: el.image.src
						});
					}
				});
				await axios.post(api.posts.comments.reply(this.value.id), {
					text:        this.text,
					attachments: attachments
				}).then(async(response) => {
					this.text = '';
					this.media = [];
					this.showReply = false;
					await this.getComment();
				});
			}
		},
		async deleteComment() {
			EventBus.$emit('confirm', {
				onOk: () => {
					axios.delete(api.posts.comments.delete(this.value.id)).then(async(response) => {
						this.$toastr.i('<div class="toastr"><div class="toastr__check"></div><p class="toastr__text">Comment has been deleted</p></div>');
						this.$emit('delete');
					});
				},
				message: 'Do you really want to delete this comment?'
			});
		},
	},
	watch: {
		showReply() {
			if (this.showReply) {
				setTimeout(() => {
					this.$refs.input.focus();
				}, 0);
			}
		}
	}
};
</script>
